<template>
    <b-modal
        id="add-slide-modal"
        v-model="modal"
        :title="$t('lesson.add_slide')"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        @ok="save"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        modal-class="apprentice-default-modal add-slide-modal"
        size="xl"
        :no-enforce-focus="true">
        <div class="slides-wrapper">
            <div class="slides-picker">
                <div
                    class="simple slide"
                    :class="{ selected: type === 1 }"
                    @click="toggleSlide(1)">
                    <i class="fad fa-file-alt fa-fw icon"></i>
                    <p class="description">
                        {{ $t('presentation.slide_with_text_and_images') }}
                    </p>
                </div>

                <div class="image slide"
                     :class="{ selected: type === 5}"
                     @click="toggleSlide(5)">
                    <i class="fad fa-image fa-fw icon"></i>
                    <p class="description">
                        {{ $t('presentation.slide_with_single_image') }}
                    </p>
                </div>

                <div
                    class="video slide"
                    :class="{ selected: type === 2 }"
                    @click="toggleSlide(2)">
                    <i class="fa fa-file-video fa-fw icon"></i>
                    <p class="description">
                        {{ $t('presentation.slide_for_entering_youtube_link') }}
                    </p>
                </div>
            </div>

            <div
                class="slide-options"
                v-if="type !== null">
                <b-alert
                    v-if="errorsFound"
                    variant="danger"
                    show>
                    Het invoer veld mag niet leeg zijn.
                </b-alert>
                <ckeditor
                    class="simple-slide-option"
                    v-model="value"
                    v-if="type === 1"
                    ref="editorInstance"
                    :editor="editor"
                    :config="editorConfig">
                </ckeditor>

                <div class="image-slide-option"
                     v-if="type === 5">
                    <div class="preview-slide" v-if="imageSRC">
                        <img class="slide-image"  :src="imageSRC" />
                    </div>

                    <b-form-file
                        class="apprentice-file-upload"
                        v-model="file"
                        :state="Boolean(file)"
                        :placeholder="$t('files.choose_file') + '...'"
                        drop-placeholder="Drop file here...">
                    </b-form-file>
                </div>

                <div
                    class="video-slide-option"
                    v-if="type === 2">
                    <label for="input-video-slide-option">{{ $t('assignment.youtube_link') }}</label>
                    <b-form-input
                        id="input-video-slide-option"
                        v-model="value"
                        :placeholder="$t('assignment.set_youtube_link')">
                    </b-form-input>
                    <design-2021-apprentice-video-link-player-component
                        v-if="value"
                        :options="playerOptions"
                        :src="value">
                    </design-2021-apprentice-video-link-player-component>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
import ApprenticeEditor from '../../../../../../helpers/ApprenticeEditor';

export default {
    name: 'design-2021-lesson-manual-add-slide-modal',
    props: {
        lessonIn: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            textBlock: null,
            modal: false,
            type: null,
            value: null,
            file: null,
            editor: ApprenticeEditor,
            editorConfig: {
                bodyClass: 'mybodyclass',
                toolbar: {
                    items: [
                        'undo',
                        'redo',
                        '|',
                        'heading',
                        '|',
                        'bold',
                        'italic',
                        'underline',
                        '|',
                        'link',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'outdent',
                        'indent',
                        'alignment',
                        '|',
                        'imageInsert',
                        'mediaEmbed',
                        'insertTable',
                        '|',
                        'fontColor',
                        'fontFamily',
                        'fontSize',
                        'fontBackgroundColor',
                        'highlight',
                        'specialCharacters',
                        '|',
                        'horizontalLine'
                    ]
                },
                language: this.$authUser.locale,
                image: {
                    toolbar: [
                        'imageTextAlternative',
                        '|',
                        'imageStyle:alignLeft',
                        'imageStyle:alignRight',
                        'imageStyle:alignCenter',
                        'imageStyle:alignBlockLeft',
                        'imageStyle:alignBlockRight',
                        'imageStyle:inline',
                        '|',
                        'linkImage'
                    ]
                },
                table: {
                    contentToolbar: ['tableColumn', 'tableRow', 'mergeTableCells']
                }
            },
            errorsFound: false,
            playerOptions: {
                responsive: true,
                autoplay: false,
                controls: true
            }
        };
    },
    computed: {
        imageSRC() {
            if (this.file === null) return null;

            return URL.createObjectURL(this.file);
        }
    },
    methods: {
        show(textBlock) {
            this.textBlock = textBlock;
            this.type = null;
            this.value = '';
            this.file = null;
            this.modal = true;
            this.errorsFound = false;
        },

        save(bvModalEvent) {
            if (this.hasErrors()) {
                bvModalEvent.preventDefault();
                this.errorsFound = true;
                return;
            }

            let formData = new FormData();
            if(this.file){
                formData.append('file', this.file);
            }

            formData.append('type', this.type);
            formData.append('value', this.value);

            this.alert.saving();

            this.axios.post(this.routes.lessonManualStoreSlide(this.lessonIn.id, this.textBlock.id), formData).then(
                (response) => {
                    this.$emit('lesson-updated', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError;
                }
            );
        },
        hasErrors() {
            if (this.type !== 5) {
                return this.value === null || this.value === '';
            } else {
                return !this.file;
            }
        },

        toggleSlide(type) {
            this.type = type;
            this.value = '';
            this.errorsFound = false;
        }
    }
};
</script>

<style scoped lang="scss">
.slides-picker {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    gap: $grid-gutter-width;

    .slide {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        gap: map-get($grid-gutter-spacing, 'fifteen');
        background-color: $secondary-background-color;
        flex: 0 1 calc(25% - 15px);
        padding: map-get($grid-gutter-spacing, 'fifteen');
        border-radius: $border-radius-content;
        border: 1px solid transparent;
        align-self: stretch;

        .icon {
            font-size: 3.3125rem;
            align-self: center;
            color: $primary;
        }

        .description {
            margin-bottom: 0;
            color: $text-muted-color;
        }

        &:hover {
            cursor: pointer;
            box-shadow: 3px 0 7px rgba($primary-darken-alternative, 23%);

            .icon {
                color: $primary-darken-alternative;
            }
        }

        &.selected {
            border: 1px solid $primary-darken-alternative;

            .icon {
                color: $primary-darken-alternative;
            }
        }
    }
}


.image-slide-option ::v-deep{
    height: 51px;

    .custom-file,
    input {
        height: 51px;
    }

    label.custom-file-label {
        margin-bottom: 0
    }

    &:has(.preview-slide){
        height: 315px;
    }
}

.preview-slide {
    display: flex;
    height: 250px;
    text-align: center;
    margin-bottom: map-get($grid-gutter-spacing, 'fifteen');
}

.slide-image {
    object-fit: cover;
    object-position: center;
    width: 100%;
    height: 100%;
}

.file-upload {
    margin-bottom: 0;
}

.file-upload-save {
    display: flex;
    justify-content: flex-end;
    margin-top: map-get($grid-gutter-spacing, 'twenty-one');
}

::v-deep .slide-options {
    margin-top: map-get($grid-gutter-spacing, 'forty-two');

    .ck.ck-editor .ck.ck-editor__main {
        height: 250px;

        .ck-editor__editable_inline {
            height: inherit;
        }
    }
}
</style>
